import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import moment from 'moment';

import { DateRangePicker } from 'react-dates';
import isAfterDay from 'react-dates/src/utils/isAfterDay';
import { exportSelectors, exportActions } from '../reducer/export-reducer';
import { appTextColor, white } from '../../../styles/colors';
import { lionSelectors, LionTranslate } from '@rosetta/react-lion/dist/index';
import { LaunchpadButton } from '../../../styles/LaunchpadButton';
import { LinkButton } from '../../../styles/LinkButton';
import { MousySpinner } from '../../app/util/MousySpinner';
import { withWindowDimensions } from '@rosetta/react-common-ui';
import { isMobile as isMobileDetected } from 'react-device-detect';

const ExportHeader = styled.div(() => {
  let style = {
    fontSize: '18px',
    lineHeight: '18px',
    textAlign: 'center'
  };
  return style;
});

const DatePickerRow = styled.div(() => {
  let style = {
    margin: '40px 1px'
  };
  return style;
});

const TriggerButtonsContainer = styled.div((props) => {
  let style = {
    textAlign: 'center',
    width: !props.isMobile ? '80%' : '100%',
    margin: 'auto'
  };
  return style;
});

const TriggerButton = styled(LaunchpadButton)((props) => {
  let style = {
    paddingLeft: '20px',
    paddingRight: '20px',
    fontSize: '16px',
    marginBottom: !props.isMobile ? '30px' : '0'
  };
  if (props.isMobile) {
    style.borderRadius = '4px';
    style.marginTop = '25px';
  }
  return style;
});

const DismissButton = styled(LinkButton)((props) => {
  let style = {
    position: 'absolute',
    right: !props.isMobile ? '25px' : '20px',
    top: !props.isMobile ? '20px' : '10px',
    color: appTextColor,
    fontSize: !props.isMobile ? '25px' : '16px'
  };
  return style;
});

const TriggerBox = styled.div((props) => {
  let style = {
    position: !props.isMobile ? 'absolute' : 'fixed',
    left: !props.isMobile ? '37%' : '16px',
    top: !props.isMobile ? '20%' : '66px',
    padding: !props.isMobile ? '40px 50px 10px' : '16px',
    zIndex: '999',
    backgroundColor: white,
    color: appTextColor,
    borderRadius: '4px',
    minHeight: '200px'
  };
  if (!props.isMobile) {
    style.width = '400px';
  } else {
    style.right = '16px';
  }
  return style;
});

const TriggerError = styled(ExportHeader)(() => {
  let style = {
    paddingBottom: '30px'
  };
  return style;
});

const MousySpinnerContainer = styled.div({
  margin: '50px 45%'
});

//*********************************************
export class ExportReportModal extends PureComponent {
  componentWillMount = () => {};

  constructor(props) {
    // functions required for datepicker.
    super(props);

    let focusedInput = null;

    this.state = {
      focusedInput,
      startDate: props.initialStartDate,
      endDate: props.initialEndDate
    };

    this.onDatesChange = this.onDatesChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
  }

  onDatesChange({ startDate, endDate }) {
    const { stateDateWrapper } = this.props;
    this.setState({
      startDate: startDate && stateDateWrapper(startDate),
      endDate: endDate && stateDateWrapper(endDate)
    });
  }

  onFocusChange(focusedInput) {
    this.setState({ focusedInput });
  }

  /*
    render!
  */
  render = () => {
    moment.locale(this.props.currentLocale);
    const isMobile = isMobileDetected;
    let startDatePlaceholder = this.props.lionTranslateString('export_modal_from');
    let endDatePlaceholder = this.props.lionTranslateString('export_modal_to');

    let closeButton = (
      <DismissButton
        data-qa="dismissDatePopup"
        onClick={() => this.props.setExportPopupView(false)}
        isMobile={isMobile}
      >
        &#x2715;
      </DismissButton>
    );

    let error = null;
    if (this.props.showPopupErrorView) {
      error = (
        <TriggerBox isMobile={isMobile}>
          {closeButton}
          <TriggerError>
            <LionTranslate lionkey="error_internal_exception" />
          </TriggerError>
        </TriggerBox>
      );
    }

    let spinner = null;
    if (this.props.triggerDownload) {
      spinner = (
        <TriggerBox isMobile={isMobile}>
          <MousySpinnerContainer>
            <MousySpinner />
          </MousySpinnerContainer>
        </TriggerBox>
      );
    }

    let datePickerForm = null;
    if (this.props.showDatePicker) {
      datePickerForm = (
        <TriggerBox isMobile={isMobile}>
          {closeButton}
          <ExportHeader isMobile={isMobile}>
            <LionTranslate lionkey="export_modal_header" />
          </ExportHeader>
          <DatePickerRow>
            <DateRangePicker
              startDatePlaceholderText={startDatePlaceholder}
              endDatePlaceholderText={endDatePlaceholder}
              startDate={this.state.startDate}
              startDateId="exportStartDate"
              endDate={this.state.endDate}
              endDateId="exportEndDate"
              onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
              focusedInput={this.state.focusedInput}
              onFocusChange={(focusedInput) => this.setState({ focusedInput })}
              isOutsideRange={(day) => isAfterDay(day, moment())}
              initialVisibleMonth={() => moment().subtract(1, 'month')}
              numberOfMonths={isMobile ? 1 : 2}
            />
          </DatePickerRow>
          <TriggerButtonsContainer isMobile={isMobile}>
            <TriggerButton
              data-qa="launchOptionalTrigger"
              onClick={() => this.props.generateExport(this.state.startDate, this.state.endDate)}
              disabled={!this.state.startDate || !this.state.endDate}
              isMobile={isMobile}
            >
              <LionTranslate lionkey="export_modal_export" />
            </TriggerButton>
          </TriggerButtonsContainer>
        </TriggerBox>
      );
    }

    let downloadButtons = null;
    if (this.props.showDownloadButtons) {
      downloadButtons = (
        <TriggerBox isMobile={isMobile}>
          {closeButton}
          <TriggerButtonsContainer isMobile={isMobile}>
            <TriggerButton
              data-qa="downloadCSV"
              onClick={() => this.props.downloadReport(this.props.reportId, 'csv')}
              isMobile={isMobile}
            >
              <LionTranslate lionkey="export_modal_download_csv" />
            </TriggerButton>
            <TriggerButton
              data-qa="downloadXLSX"
              onClick={() => this.props.downloadReport(this.props.reportId, 'xlsx')}
              isMobile={isMobile}
            >
              <LionTranslate lionkey="export_modal_download_xlsx" />
            </TriggerButton>
          </TriggerButtonsContainer>
        </TriggerBox>
      );
    }

    return (
      <div>
        {datePickerForm}
        {spinner}
        {downloadButtons}
        {error}
      </div>
    );
  };
}

ExportReportModal.propTypes = {};

const mapStateToProps = (state, ownprops) => ({
  lionTranslateString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  },
  currentLocale: lionSelectors.getLionLanguage(state),
  triggerDownload: exportSelectors.showPopupSpinnerView(state),
  showDatePicker: exportSelectors.showPopupDatePickerView(state),
  showDownloadButtons: exportSelectors.showPopupDownloadView(state),
  showPopupErrorView: exportSelectors.showPopupErrorView(state),
  reportId: exportSelectors.reportId(state)
});

const wrapActions = {
  setExportPopupView: exportActions.setExportPopupView,
  generateExport: exportActions.generateExport,
  downloadReport: exportActions.downloadReport
};
export const ExportReportContainer = connect(
  mapStateToProps,
  wrapActions
)(withWindowDimensions(ExportReportModal));



// WEBPACK FOOTER //
// ./src/modules/launchpad/components/ExportReport.jsx